








































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@/utils/decorator";
import { emptyToLine, splitThousands } from "@/utils/common";
import DataImport from "@/components/scope/data-import.vue";

const customer = namespace("customer");

@Component({
  components: { DataImport }
})
@Table("loadListData")
@Table.DataImport({
  templateUrl: "https://static.gtech.asia/static/template/speedbiz/客户车辆导入.xlsx",
  actionUrl: "/filecloud/importCustomerVehicles"
})
export default class Customer extends Vue {
  @customer.Action getCustomerList;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  searchForm = {
    plateCode: "",
    vinCode: "",
    customerName: "",
    mobile: ""
  };
  showImport: boolean = false;
  customerList: any[] = [];
  searchList: any[] = [
    {
      label: window._I18N.t("finance.license-plate-number"),
      type: "input",
      value: "",
      prop: "plateCode"
    },
    {
      label: window._I18N.t("test.vin-code"),
      type: "input",
      value: "",
      prop: "vinCode"
    },
    {
      label: window._I18N.t("finance.guest-names"),
      type: "input",
      value: "",
      prop: "customerName"
    },
    {
      label: window._I18N.t("base.phone"),
      type: "input",
      value: "",
      prop: "mobile"
    }
  ];

  created() {
    this.init();
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getCustomerList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.customerList = data.data.list;
      return data;
    });
  }
  handleEdit(row) {
    this.$router.push(`/setting/customer-edit/${row.customerCode}?vehicleCode=${row.vehicleCode}`);
  }
  handleView(row) {
    this.$router.push(`/setting/customer-view/${row.customerCode}?vehicleCode=${row.vehicleCode}`);
  }
  handleShowImport() {
    this.showImport = true;
  }
  init() {
    this.loadListData();
  }
}
